import { handleSystemErrorReport } from '@mb/lib/utils';
import { client } from '../../api/http';
import { config } from '../../config';

export const fetchServices = async (productId: string) => {
  try {
    const bodyFormData = new FormData();
    bodyFormData.append('product_id[0]', productId);
    const { data } = await client.post(
      config.endpoints.getServices,
      bodyFormData,
    );
    const response = data.response ? data : null;

    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Error fetchServices >>> ', error.message);
    handleSystemErrorReport(
      `Error fetchServices >>> ${error.message}`,
      'fetchServices',
    );
    return null;
  }
};
